import { parseInvalidDate, formatDateTime, addTime, formatWithInstance } from 'common/utilities/dayJsUtils';
import SELECT_CONTENT_DISPOSITION_CONSTANTS, {
  OUT_OF_SERVICE,
  CLOSED,
} from '../Constants/selectContentDispositionConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getValueOrDefaultObject } from 'common/utilities/utils';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import { getDataLayer } from '../../../common/utilities/utils';
import { DISPOSITION_KEYS } from 'common/constants/SharedConstants';

/**
 *
 * @param {*} data - disposition content module data - Object
 */
export const modifyDataDisposition = dispositionData => {
  const { url: src = '' } =
    (dispositionData.headline && dispositionData?.headline[0]?.fields?.desktopImage?.fields?.file) || {};
  const { title: alt = '' } =
    (dispositionData.headline && dispositionData?.headline[0]?.fields?.desktopImage?.fields) || {};
  const { headline = '', subHeadline = '' } = (dispositionData.headline && dispositionData.headline[1]?.fields) || {};
  const { supportedDispositions = [] } = dispositionData;
  const supportedDispositionsData = supportedDispositions.map(item => item.fields);
  return { headline, subHeadline, supportedDispositionsData, src, alt };
};

/**
 * Method to get available time slot
 */
export const availableTimeSlot = (selectedTime, storeInfo, tenantData) => {
  const storeStatus = storeInfo?.summary?.status?.currentStatus || CLOSED;

  const { futureDates, scheduled: initiallyScheduled, asap } = getValueOrDefaultObject(storeInfo?.summary?.timings);
  const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
  const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
    initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
  );
  const { from, to } = getValueOrDefaultObject(startEndTime);

  let availableSlots = getList(
    from,
    to,
    initialInterval,
    asap?.isAvailable,
    futureDates?.length === 1 && tenantData?.country?.toUpperCase() === 'INDIA',
    unavailibilities,
  );

  if ((storeStatus === CLOSED && !availableSlots.length) || !selectedTime?.time) {
    return translateWithI18Next(OUT_OF_SERVICE);
  }
  const startTimings = selectedTime.time;
  const interval = selectedTime.interval;
  const date = typeof selectedTime.date == 'object' ? selectedTime.date : new Date(selectedTime.date);
  const parseTime = parseInvalidDate(formatDateTime(date, 'YYYY-MM-DD') + ' ' + startTimings, 'YYYY-MM-DD hh:mm A');
  const addedTime = addTime(parseTime, interval, 'minutes');
  const endTiming = formatWithInstance(addedTime, 'LT');
  return startTimings === 'ASAP' ? `${startTimings}` : `${startTimings} - ${endTiming}`;
};

/**
 * Method to set analytics items in the data layer object
 */
export const dispositionChangeAnalytics = async type => {
  const analyticsItems = [];
  analyticsItems.push({
    event: 'orderType',
    dispositionSelected: type,
  });
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

const { ORDER_TYPE_STORE_INFO_FROM, ORDER_TYPE_STORE_INFO_TO, ORDER_TYPE_STORE_INFO_AT } =
  SELECT_CONTENT_DISPOSITION_CONSTANTS;
const { DELIVERY, DINE_IN, PICKUP } = DISPOSITION_KEYS;

export const getPrepositionByDispositionType = dispositionType => {
  switch (dispositionType?.toUpperCase()) {
    case DELIVERY:
      return ORDER_TYPE_STORE_INFO_TO;
    case DINE_IN:
      return ORDER_TYPE_STORE_INFO_AT;
    case PICKUP:
      return ORDER_TYPE_STORE_INFO_FROM;
    default:
      return undefined;
  }
};
